import { render, staticRenderFns } from "./LinksArea.vue?vue&type=template&id=c26f62c2&"
import script from "./LinksArea.vue?vue&type=script&lang=js&"
export * from "./LinksArea.vue?vue&type=script&lang=js&"
import style0 from "./LinksArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports